export default {
	APP_NAME: process.env.REACT_APP_NAME,
  MAINTAIN_MODE: process.env.REACT_APP_MAINTAIN_MODE
};
